import { useMemo } from 'react'

import { useCompanyLeadSourceOptions } from 'src/hooks/useCompanyLeadSourceOptions/useCompanyLeadSourceOptions'

import { FilterOption } from '../types'

interface UseLeadSourcesFilterProps {
  selectedLeadSources: string[]
  onLeadSourcesChange: (leadSources: string[]) => void
}

export const useLeadSourcesFilter = ({
  selectedLeadSources,
  onLeadSourcesChange,
}: UseLeadSourcesFilterProps) => {
  const {
    options: baseOptions,
    loadData,
    loading,
    isLoaded,
  } = useCompanyLeadSourceOptions()

  // Reflect the current selection on the top-level (link type) options; the
  // nested option tree itself is built by the shared hook.
  const options = useMemo<FilterOption[]>(
    () =>
      baseOptions.map((option) => ({
        ...option,
        selected: selectedLeadSources.includes(option.value),
      })),
    [baseOptions, selectedLeadSources]
  )

  return {
    options,
    selected: selectedLeadSources,
    onChange: onLeadSourcesChange,
    loadData,
    loading,
    isLoaded,
  }
}
